import { MAIN } from "../../../routes/constants";
import Proposal from "./Proposal";
import ViewProposal from "./ViewProposal";
import AddProduct from "./AddProduct";
import AddPartner from "./AddPartner";

//Module Page Routes
export const PROPOSALS = MAIN + "/Proposals";
export const NEW_PROPOSAL = MAIN + "/Proposals/new";
export const EDIT_PROPOSAL = MAIN + "/Proposals/edit";
export const ADD_PROPOSAL_PRODUCT = "/AddProduct";
export const ADD_PROPOSAL_PARTNER = "/AddPartner";

const ProductClassRoutes = [
    {
        label: "PROPOSALS",
        path: PROPOSALS,
        component: Proposal,
        exact: true,
        mainscreen: true
    },
    {
        label: "NEW PROPOSAL",
        path: NEW_PROPOSAL,
        component: ViewProposal,
        exact: true,
    },
    {
        label: "EDIT PROPOSAL",
        path: EDIT_PROPOSAL + "/:id?",
        component: ViewProposal,
        exact: true,
    },
    {
        label: "ADD PRODUCT",
        path: EDIT_PROPOSAL + "/:id" + ADD_PROPOSAL_PRODUCT,
        component: AddProduct,
        exact: true,
    },
    {
        label: "ADD PARTNER",
        path: EDIT_PROPOSAL + "/:id" + ADD_PROPOSAL_PARTNER,
        component: AddPartner,
        exact: true,
    }
];

export default ProductClassRoutes;